import { Ban } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@reflex/ui/components/ui/alert';
import { Button } from '@reflex/ui/components/ui/button';
import { useAuth } from '@/hooks/auth/useAuth';

const SUPPORT_EMAIL = 'support@runloop.ai';

/**
 * Full-viewport screen rendered when the authenticated user's account
 * is disabled. Replaces the entire app shell so a disabled user cannot
 * mount the sidebar, command palette, or any feature page. The server
 * also rejects every authenticated API call from this user with
 * `403 account_disabled` — this screen is the user-facing half of that
 * gate.
 */
export function AccountDisabledScreen() {
  const { logout } = useAuth();
  return (
    <div className="flex min-h-dvh items-center justify-center bg-background px-4">
      <Alert variant="destructive" className="max-w-md">
        <Ban className="h-4 w-4" />
        <AlertTitle>Your account is disabled</AlertTitle>
        <AlertDescription className="space-y-4">
          <p>
            Your account has been disabled. To get it re-enabled, please email{' '}
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              className="font-medium underline underline-offset-2"
            >
              {SUPPORT_EMAIL}
            </a>
            .
          </p>
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={() => {
              void logout();
            }}
          >
            Sign out
          </Button>
        </AlertDescription>
      </Alert>
    </div>
  );
}
